import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { draftTask } from 'api/task.service';
import { useToast } from 'hooks/ui';
import { Task } from 'models/task.model';
import { setDraftTask } from 'store/task.store';
import { useNavigate } from 'react-router-dom';

type HookArgs = {
  keepActive?: boolean;
};

export const useTaskCreateQuery = (props: HookArgs = { keepActive: false }) => {
  const toast = useToast();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { isLoading, mutate, data } = useMutation(
    (task: Task) =>
      draftTask({
        title: task.title,
        description: task.description,
        errorMessage: task.errorMessage,
        validator: task.validator,
        workModels: task.workModels,
        ...(task.validator === 'CONTAINS'
          ? { answer: task.answer.trim() }
          : { answer: null }),
      }),
    {
      onSuccess: (task) => {
        queryClient.invalidateQueries(['tasks']);
        toast.success('Task has been drafted successfully');

        if (props.keepActive) {
          setDraftTask(task);
          navigate(`/tasks/${task.id}`);
        }
      },
      onError: (error: AxiosError) => {
        toast.error(error.message);
      },
    },
  );

  return { isLoading, mutate, data };
};
